import {calcFarmRemainingSupply} from "../calcFarmRemainingSupply";

/**
 * Сколько снабжения дадут все РАБОЧИЕ фермы игрока суммарно.
 *
 * Считается тем же calcFarmRemainingSupply, что и подпись под каждой фермой,
 * поэтому в сумму сами собой попадают и удвоение от склада, и уже розданное
 * за этот ход снабжение. Ферма, заблокированная вражеским отрядом, возвращает
 * оттуда FARM_SUPPLY_BLOCKED_COUNT (-1) — отрицательный вклад в СУММЕ был бы
 * бессмыслицей («минус одно снабжение»), поэтому нерабочие фермы просто не
 * учитываются: ноль и есть их вклад.
 *
 * @param {string[]} farmHexKeys - фермы игрока (см. getPlayerFarms)
 * @param {Object} context - то же, что нужно calcFarmRemainingSupply
 * @returns {number}
 */
export const calcWorkingFarmsSupply = (farmHexKeys, {
  selectedFarmsForConversion, hexes, specialBuildings, players, units, citiesCache,
  currentPlayer, pendingSupply, buildingsDamage,
}) => {
  return (farmHexKeys || []).reduce((total, farmHexKey) => {
    const remaining = calcFarmRemainingSupply(
      farmHexKey, selectedFarmsForConversion, hexes, specialBuildings, players, units,
      citiesCache, currentPlayer, pendingSupply, buildingsDamage
    );
    return total + Math.max(0, remaining);
  }, 0);
};
